import React, { Component } from 'react';
import { Layout } from 'layouts';
import {
  PageHeader,
  TechnologyPartners,
  BrandsWorkedWithUs,
} from '@components';
import {
  BetterThanOther,
  MultiColumnList,
  MultiColumnContent,
} from '@components/industries';
import Heading from '@components/pageHeading';
import PageNavigation from '@components/pageNavigation';
import pageContent from '@constants/industries';

class VirtualReality extends Component {
  render() {
    const virtualReality = pageContent.subPage.virtualReality;
    return (
      <Layout>
        <PageHeader image={virtualReality.headerImage} />

        <Heading
          title={virtualReality.title}
          overview={virtualReality.overview}
          noHeadingIcon={true}
        />

        <BetterThanOther content={virtualReality.betterThanOther} />

        <MultiColumnList content={virtualReality.servicesAndSolutions} />

        <MultiColumnList content={virtualReality.servicesWorkOn} />

        <MultiColumnContent content={virtualReality.vrHelp} />

        <PageNavigation
          prev={pageContent.navigation.prev}
          next={pageContent.navigation.next}
        />

        <TechnologyPartners />

        <BrandsWorkedWithUs />
      </Layout>
    );
  }
}

export default VirtualReality;
